module.exports = __webpack_public_path__ + "img/israel.2d7ed5d5.svg";